<div class="modall">
  <div class="close-button" (click)="onClose()">
    <img src="assets/svg/closeButton.svg">
  </div>
  @if (data.message == REQUEST_PAYMENT_DIALOG) {
    <div [formGroup]="paymentForm">
      <div class="modal-header">
        <h2>{{ 'activity.request_payment_modal.title' | translate }}</h2>
        <p>{{ 'activity.request_payment_modal.your_balance' | translate }}: <strong class="fs-18">{{ BalanceFormatterUtil.getFormattedBalance(data.balance )}}</strong></p>
      </div>
      <div class="modal-body">
        <div class="input-container">
          <span class="currency-icon">{{ currency }}</span>
          <input type="text" (input)="onAmountInput($event)" formControlName="amount"
                 [placeholder]="BalanceFormatterUtil.getFormattedBalance(data.balance)"/>
        </div>
        @if (hasAmountError) {
          <div class="error-message mt-1">
            {{ errorMessage }}
          </div>
        }
        <mat-divider class="divider"></mat-divider>
        <div class="scrollable-content">
          @for (creditCard of creditCards; track creditCard) {
            <div class="card-item mt-3">
              <input class="large-radio" type="radio" id="{{creditCard.id}}" (click)="editCreditCard(creditCard)"
                     formControlName="creditCardId" [value]="creditCard.id"
                     name="creditCardId">
              <label for="{{creditCard.id}}">
              <span class="font-size-18 me-3">
              ********{{ getLastFourDigits(creditCard.accountNumber) }}
              </span>
                <img class="width-3 me-3" src="../../../assets/svg/gray-payments.svg" alt="MasterCard">
                <mat-icon class="copy-btn" (click)="copyCode(creditCard)">content_copy</mat-icon>
              </label>
              @if (!creditCard.isSelected) {
                <button class="delete-icon-button delete-icon" (click)="deleteCard(creditCard.id)">
                  <mat-icon class="clear-icon-create-or-edit">close</mat-icon>
                </button>
              }
            </div>
          }
        </div>
        <div class="request-container">
          <p>{{ 'activity.request_payment_modal.request_with' | translate }}</p>
          <button class="add-card" (click)="openAddCreditCardDialog()">
            {{ 'activity.request_payment_modal.add_bank_account' | translate }}
            <mat-icon class="plus-icon">add</mat-icon>
          </button>
        </div>
      </div>
      <div class="modal-actions">
        <button class="cancel-button option-shared mobile-button" mat-dialog-close (click)="onClose()">{{ 'activity.request_payment_modal.cancel' | translate }}</button>
        <button class="request-button option-shared btn mobile-button" [disabled]="!data.balance" (click)="onSubmit()">{{ 'activity.request_payment_modal.request' | translate }}</button>
      </div>
    </div>

  }
  @if (data.message == ADD_CREDIT_CARD_DIALOG) {
    <div [formGroup]="creditCardForm">
      <div class="modal-header">
        <h2>{{ 'activity.add_bank_account_modal.title' | translate }}</h2><br>
      </div>
      <div class="modal-body modal-body-gap">
        <div class="input-container request-container">
          <input [type]="accountNumberInputType" formControlName="accountNumber" placeholder="{{ 'activity.add_bank_account_modal.bank_account' | translate }} *"
                 class="credit-card-input" (input)="onAccountNumberInput($event)" maxlength="16"
          />
          <span (click)="$event.stopPropagation(); toggleAccountNumberVisibility()"
                class="lock-icon material-icons-outlined cursor-pointer">{{ showAccountNumber ? 'lock_open' : 'lock' }}</span>
        </div>
        @if (creditCardForm.get('accountNumber')?.touched && creditCardForm.get('accountNumber')?.invalid) {
          @if (creditCardForm.get('accountNumber')?.errors?.['required']) {
            <div class="error-message">
              {{ 'activity.enter_valid_card_number' | translate }}
            </div>
          } @else if (creditCardForm.get('accountNumber')?.errors?.['pattern']) {
            <div class="error-message">
              {{ 'activity.invalid_card_number' | translate }}
            </div>
          } @else if (creditCardForm.controls['accountNumber'].hasError('pattern')) {
            <div class="error-message">
              {{ 'activity.only_numbers_allowed' | translate }}
            </div>
          }
        }
        <div class="input-container request-container">
          <input type="text" formControlName="cardholderName" placeholder="{{ 'activity.add_bank_account_modal.name_on_card' | translate }} *"/>
        </div>
        @if (creditCardForm.get('cardholderName')?.touched && creditCardForm.get('cardholderName')?.invalid) {
          <div class="error-message">
            {{ 'activity.enter_name_on_card' | translate }}
          </div>
        }
      </div>
      <div class="modal-actions">
        @if (this.data.isFromBankAccount){
          <button class="cancel-button option-shared btn mobile-button" (click)="onClose()">
            {{ 'activity.request_payment_modal.cancel' | translate }}
          </button>
          <button class="request-button option-shared btn mobile-button" [disabled]="creditCardForm.invalid"
                  (click)="saveCreditCard()">{{ 'activity.add_bank_account_modal.only_save' | translate }}
          </button>
        } @else {
          <button class="cancel-button option-shared btn mobile-button" [disabled]="creditCardForm.invalid" (click)="saveCreditCard()">
            {{ 'activity.add_bank_account_modal.only_save' | translate }}
          </button>
          <button class="request-button option-shared btn mobile-button" [disabled]="!data.balance || creditCardForm.invalid || !data.amount"
                  (click)="saveRequest()">{{ 'activity.add_bank_account_modal.save_request' | translate }}
          </button>
        }
      </div>
    </div>

  }
  @if (data.message == CREDIT_CARDS_DIALOG) {
    <div id="creditCardModal">
      <div class="modal-header">
        <h2>{{ 'activity.bank_account' | translate }}</h2>
        <span>{{ 'Choose_card_for_payment' | translate }}</span>
      </div>
      <div class="modal-body" [formGroup]="paymentForm">

        <div class="card-options">
         <div class="scrollable-content">
          @for (creditCard of creditCards; track creditCard) {
            <div class="card-item mt-2">
              <input class="large-radio" type="radio" id="{{creditCard.id}}" formControlName="creditCardId" [value]="creditCard.id"
                     name="creditCardId" (click)="changeCreditCard(creditCard)">
              <label for="{{creditCard.id}}">
                <span class="font-size-18 me-3">
                ********{{ getLastFourDigits(creditCard.accountNumber) }}
                  </span>
                <img class="width-3 me-3" src="../../../assets/svg/gray-payments.svg" alt="MasterCard">
                <mat-icon class="copy-btn" (click)="copyCode(creditCard)">content_copy</mat-icon>
              </label>
              @if (!creditCard.isSelected) {
                <button class="delete-icon-button delete-icon" (click)="deleteCard(creditCard.id)">
                  <mat-icon class="clear-icon-create-or-edit">close</mat-icon>
                </button>
              }
            </div>
          }
          </div>
          <div class="request-container">
            <button class="add-card" (click)="openAddCreditCardDialog()">
              {{ 'activity.add_bank_account_modal.title' | translate }}
              <mat-icon class="plus-icon">add</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="modal-actions">
        <button class="cancel-button option-shared" matDialogClose>{{ 'activity.request_payment_modal.cancel' | translate }}</button>
        <button class="request-button option-shared" (click)="editCreditCard(creditCard)">{{ 'activity.add_bank_account_modal.only_save' | translate }}</button>
      </div>
    </div>
  }
</div>
